module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<footer class="footer-bottom">\r\n  <div class="container-width">\r\n\r\n    <div class="copyright">\r\n        This report was automatically generated by InSilicoTrials.com - © 2019 InSilicoTrials Technologies. All Rights Reserved.\r\n    </div>\r\n\r\n  </div>\r\n</footer>';

}
return __p
}